import {
  ADD_CUSTOMER_REQUEST,
  ADD_CUSTOMER_SUCCESS,
  ADD_CUSTOMER_FAILURE,
  FETCH_CUSTOMERS_REQUEST,
  FETCH_CUSTOMERS_SUCCESS,
  FETCH_CUSTOMERS_FAILURE,
  UPDATE_CUSTOMER_REQUEST,
  UPDATE_CUSTOMER_SUCCESS,
  UPDATE_CUSTOMER_FAILURE,
  DELETE_CUSTOMER_REQUEST,
  DELETE_CUSTOMER_SUCCESS,
  DELETE_CUSTOMER_FAILURE,
  FETCH_CUSTOMER_DETAILS_REQUEST,
  FETCH_CUSTOMER_DETAILS_SUCCESS,
  FETCH_CUSTOMER_DETAILS_FAILURE,
  RESET_CUSTOMER_STATE,
  CLEAR_DELETE_SUCCESS,
  FETCH_ALL_CUSTOMERS_REQUEST,
  FETCH_ALL_CUSTOMERS_SUCCESS,
  FETCH_ALL_CUSTOMERS_FAILURE,
  RESEND_CUSTOMER_PASSWORD_REQUEST,
  RESEND_CUSTOMER_PASSWORD_SUCCESS,
  RESEND_CUSTOMER_PASSWORD_FAILURE,
  CLEAR_RESEND_PASSWORD_STATUS,
  CONVERT_VENDOR_TO_CUSTOMER_REQUEST,
  CONVERT_VENDOR_TO_CUSTOMER_SUCCESS,
  CONVERT_VENDOR_TO_CUSTOMER_FAILURE,
  CLEAR_CONVERT_VENDOR_TO_CUSTOMER_STATUS,
  CONVERT_ROLE_REQUEST,
  CONVERT_ROLE_SUCCESS,
  CONVERT_ROLE_FAILURE,
  CLEAR_CONVERT_ROLE_STATUS,
  FETCH_CUSTOMER_DROPDOWN_REQUEST,
  FETCH_CUSTOMER_DROPDOWN_SUCCESS,
  FETCH_CUSTOMER_DROPDOWN_FAILURE,
} from "../types/customerTypes";
const initialState = {
  customers: {
    data: [],
    totalRecords: 0,
    totalPages: 0,
    currentPage: 1,
    loading: false,
    error: null,
  },
  customerDetails: {
    data: null,
    loading: false,
    error: null,
    updateLoading: false,
    deleteLoading: false,
  },
  convertVendorToCustomer: {
    loading: false,
    success: false,
    error: null,
  },
  success: {
    add: false,
    update: false,
    delete: false,
  },
  resendPassword: {
    loading: false,
    success: false,
    error: null,
  },
  convertRole: {
    loading: false,
    success: false,
    error: null,
    message: null,
  },
  customerDropdown: {
    data: [],
    loading: false,
    error: null,
  },
};
const customerReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_CUSTOMER_REQUEST:
      return {
        ...state,
        customerDetails: {
          data: null,
          loading: false,
          error: null,
          updateLoading: true,
          deleteLoading: false,
        },
      };
    case DELETE_CUSTOMER_REQUEST:
      return {
        ...state,
        customerDetails: {
          data: null,
          loading: false,
          error: null,
          updateLoading: false,
          deleteLoading: true,
        },
      };
    case ADD_CUSTOMER_REQUEST:
    case FETCH_CUSTOMER_DETAILS_REQUEST:
      return {
        ...state,
        customerDetails: {
          data: null,
          loading: true,
          error: null,
          updateLoading: false,
          deleteLoading: false,
        },
      };

    case FETCH_CUSTOMERS_REQUEST:
      return {
        ...state,
        customers: {
          ...state.customers,
          loading: true,
          error: null,
        },
        customerDetails: {
          data: null,
          loading: true,
          error: null,
          updateLoading: false,
          deleteLoading: false,
        },
        success: { add: false, update: false, delete: false },
      };
    case FETCH_ALL_CUSTOMERS_REQUEST:
      return {
        ...state,
        customers: {
          ...state.customers,
          loading: true,
          error: null,
        },
        customerDetails: {
          data: null,
          loading: true,
          error: null,
          updateLoading: false,
          deleteLoading: false,
        },
        success: { add: false, update: false, delete: false },
      };
    case ADD_CUSTOMER_SUCCESS:
      return {
        ...state,
        customers: { ...state.customers, loading: false },
        customerDetails: {
          loading: false,
          error: null,
          data: action.payload,
          updateLoading: false,
          deleteLoading: false,
        },
        success: { ...state.success, add: true },
      };
    case FETCH_CUSTOMERS_SUCCESS:
      return {
        ...state,
        customers: {
          ...state.customers,
          data: action.payload.data,
          totalRecords: action.payload.totalRecords,
          activeCustomerCount: action.payload.activeCustomerCount,
          thisMonthCustomerCount: action.payload.thisMonthCustomerCount,
          totalPages: action.payload.totalPages,
          currentPage: action.payload.currentPage,
          loading: false,
          error: null,
        },
      };
    case FETCH_ALL_CUSTOMERS_SUCCESS:
      return {
        ...state,
        customers: {
          ...state.customers,
          data: action.payload.data,
          totalRecords: action.payload.totalRecords,
          activeCustomerCount: action.payload.activeCustomerCount,
          thisMonthCustomerCount: action.payload.thisMonthCustomerCount,
          totalPages: action.payload.totalPages,
          currentPage: action.payload.currentPage,
          loading: false,
          error: null,
        },
      };
    case UPDATE_CUSTOMER_SUCCESS:
      return {
        ...state,
        customers: { ...state.customers, loading: false },
        customerDetails: {
          loading: false,
          error: null,
          updateLoading: false,
          deleteLoading: false,
        },
        success: { ...state.success, update: true },
      };
    case FETCH_CUSTOMER_DETAILS_SUCCESS:
      return {
        ...state,
        customerDetails: {
          data: action.payload,
          loading: false,
          error: null,
          updateLoading: false,
          deleteLoading: false,
        },
      };
    case DELETE_CUSTOMER_SUCCESS:
      return {
        ...state,
        customers: {
          ...state.customers,
          data: state.customers.data.filter(
            (customer) => customer.id !== action.payload,
          ),
          customerDetails: {
            loading: false,
            error: null,
            updateLoading: false,
            deleteLoading: false,
          },
          loading: false,
        },
        success: { ...state.success, delete: true },
      };

    case FETCH_CUSTOMERS_FAILURE:
      return {
        ...state,
        customers: {
          ...state.customers,
          loading: false,
          error: action.payload,
        },
        success: { add: false, update: false, delete: false },
      };
    case FETCH_ALL_CUSTOMERS_FAILURE:
      return {
        ...state,
        customers: {
          ...state.customers,
          data: [],
          loading: false,
          error: action.payload,
        },
        success: { add: false, update: false, delete: false },
      };
    case ADD_CUSTOMER_FAILURE:
    case FETCH_CUSTOMER_DETAILS_FAILURE:
    case UPDATE_CUSTOMER_FAILURE:
    case DELETE_CUSTOMER_FAILURE:
      return {
        ...state,
        customerDetails: {
          ...state.customerDetails,
          data: null,
          loading: false,
          error: action.payload,
          updateLoading: false,
          deleteLoading: false,
        },
        success: { add: false, update: false, delete: false },
      };
    case RESET_CUSTOMER_STATE:
      return {
        ...initialState,
        customers: {
          ...state.customers,
          data: [],
          loading: false,
          error: null,
        },
        success: {
          add: false,
          update: false,
          delete: false,
        },
        customerDetails: {
          ...state.customerDetails,
          data: [],
          loading: false,
          error: null,
          updateLoading: false,
          deleteLoading: false,
        },
      };
    case RESEND_CUSTOMER_PASSWORD_REQUEST:
      return {
        ...state,
        resendPassword: {
          loading: true,
          success: false,
          error: null,
        },
      };

    case RESEND_CUSTOMER_PASSWORD_SUCCESS:
      return {
        ...state,
        resendPassword: {
          loading: false,
          success: true,
          error: null,
        },
      };

    case RESEND_CUSTOMER_PASSWORD_FAILURE:
      return {
        ...state,
        resendPassword: {
          loading: false,
          success: false,
          error: action.payload,
        },
      };

    case CLEAR_RESEND_PASSWORD_STATUS:
      return {
        ...state,
        resendPassword: {
          loading: false,
          success: false,
          error: null,
        },
      };

    case CONVERT_VENDOR_TO_CUSTOMER_REQUEST:
      return {
        ...state,
        convertVendorToCustomer: { loading: true, success: false, error: null },
      };
    case CONVERT_VENDOR_TO_CUSTOMER_SUCCESS:
      return {
        ...state,
        convertVendorToCustomer: {
          loading: false,
          success: true,
          error: null,
          message: action.payload,
        },
      };
    case CONVERT_VENDOR_TO_CUSTOMER_FAILURE:
      return {
        ...state,
        convertVendorToCustomer: {
          loading: false,
          success: false,
          error: action.payload,
        },
      };
    case CLEAR_CONVERT_VENDOR_TO_CUSTOMER_STATUS:
      return {
        ...state,
        convertVendorToCustomer: {
          loading: false,
          success: false,
          error: null,
        },
      };
    case CONVERT_ROLE_REQUEST:
      return {
        ...state,
        convertRole: {
          loading: true,
          success: false,
          error: null,
          message: null,
        },
      };
    case CONVERT_ROLE_SUCCESS:
      return {
        ...state,
        convertRole: {
          loading: false,
          success: true,
          error: null,
          message: action.payload,
        },
      };
    case CONVERT_ROLE_FAILURE:
      return {
        ...state,
        convertRole: {
          loading: false,
          success: false,
          error: action.payload,
          message: null,
        },
      };
    case CLEAR_CONVERT_ROLE_STATUS:
      return {
        ...state,
        convertRole: {
          loading: false,
          success: false,
          error: null,
          message: null,
        },
      };
    case FETCH_CUSTOMER_DROPDOWN_REQUEST:
      return {
        ...state,
        customerDropdown: {
          ...state.customerDropdown,
          loading: true,
          error: null,
        },
      };

    case FETCH_CUSTOMER_DROPDOWN_SUCCESS:
      return {
        ...state,
        customerDropdown: {
          ...state.customerDropdown,
          data: action.payload,
          loading: false,
          error: null,
        },
      };

    case FETCH_CUSTOMER_DROPDOWN_FAILURE:
      return {
        ...state,
        customerDropdown: {
          ...state.customerDropdown,
          loading: false,
          error: action.payload,
        },
      };

    default:
      return state;
  }
};
export default customerReducer;
